import { MarkerFromMarkersData } from '@/models/markers-data.model';

const ORDER_OF_MARKERS = [
    '_MARKER_LivingRoom',
    '_MARKER_LivingRoom_0',
    '_MARKER_Hall',
    '_MARKER_Hall_0',
    '_MARKER_Kitchen',
    '_MARKER_Kitchen_0',
    '_MARKER_Bedroom',
    '_MARKER_Bedroom_0',
    '_MARKER_DiningRoom',
    '_MARKER_DiningRoom_0',
    '_MARKER_Bathroom',
    '_MARKER_Bathroom_0',
    '_MARKER_Office',
    '_MARKER_Office_0',
    '_MARKER_ChildsRoom',
    '_MARKER_ChildsRoom_0',
    '_MARKER_Laundry',
    '_MARKER_Laundry_0',
    '_MARKER_Garden',
    '_MARKER_Garden_0',
    '_MARKER_Garage',
    '_MARKER_Garage_0',
    '_MARKER_Toilet',
    '_MARKER_Toilet_0',
    '_MARKER_Terrace',
    '_MARKER_Terrace_0',
    '_MARKER_Balcony',
    '_MARKER_Balcony_0',
    '_MARKER_Closet',
    '_MARKER_Closet_0',
    '_MARKER_Wardrobe',
    '_MARKER_Wardrobe_0',
];

const getDefaultMarkerNameFromMarkersArray = (markers: Array<MarkerFromMarkersData>) => {
    const firstFloorMarkers = markers.filter((m) => m.floor == null || m.floor === 0);
    let matchedMarker = firstFloorMarkers[0]?.name;

    ORDER_OF_MARKERS.find((markerName) => {
        for (let i = 0; i < firstFloorMarkers.length; i += 1) {
            if (firstFloorMarkers[i].name.includes(markerName)) {
                matchedMarker = firstFloorMarkers[i].name;
                return true;
            }
        }

        return false;
    });

    if (matchedMarker) return matchedMarker;
    return '_MARKER_LivingRoom';
};

export default getDefaultMarkerNameFromMarkersArray;
